// Generated by ReScript, PLEASE EDIT WITH CARE

import * as I18n from "../../primitives/I18n.res.js";
import * as IpAddress from "../../primitives/IpAddress.res.js";
import * as AuthRoutes from "./AuthRoutes.res.js";
import * as Navigation from "../../primitives/Navigation.res.js";
import * as AuthLoginPage from "./AuthLoginPage.res.js";
import * as AuthLogoutPage from "./AuthLogoutPage.res.js";
import * as AuthSignupPage from "./AuthSignupPage.res.js";
import * as Stylex from "@stylexjs/stylex";
import * as JsxRuntime from "react/jsx-runtime";
import * as AuthLoginResetPage from "./AuthLoginResetPage.res.js";
import * as AuthImpersonationPage from "./AuthImpersonationPage.res.js";
import * as AuthLoginRecoveryPage from "./AuthLoginRecoveryPage.res.js";
import * as AuthSignupSuccessPage from "./AuthSignupSuccessPage.res.js";
import * as AuthUsernameUpdatePage from "./AuthUsernameUpdatePage.res.js";
let styles = {
  container: {
    "backgroundColor-kWkggS": "backgroundColor-xhb2u9n",
    "alignItems-kGNEyG": "alignItems-x6s0dn4",
    "display-k1xSpc": "display-x78zum5",
    "flex-kUk6DE": "flex-x98rzlu",
    "flexDirection-kXwgrk": "flexDirection-xdt5ytf",
    "overflow-kVQacm": "overflow-xysyzu8",
    $$css: "wino-gc:src/app/Auth/AuthRouter.res.js:19"
  }
};
function AuthRouter(props) {
  let subUrlPath = props.subUrlPath;
  let newrecord = {
    ...{
      className: "backgroundColor-xhb2u9n alignItems-x6s0dn4 display-x78zum5 flex-x98rzlu flexDirection-xdt5ytf overflow-xysyzu8",
      "data-style-src": "wino-gc:src/app/Auth/AuthRouter.res.js:19"
    }
  };
  let tmp;
  let exit = 0;
  if (subUrlPath !== 0) {
    switch (subUrlPath.hd) {
      case "impersonation":
        let match = subUrlPath.tl;
        if (match !== 0 && match.tl === 0) {
          tmp = JsxRuntime.jsx(AuthImpersonationPage.make, {
            userId: match.hd,
            authLogoutImpersonationFailureRoute: AuthRoutes.logoutImpersonationFailureRoute,
            appIndexRoute: props.appIndexRoute
          });
        } else {
          exit = 1;
        }
        break;
      case "login":
        let match$1 = subUrlPath.tl;
        if (match$1 !== 0) {
          switch (match$1.hd) {
            case "impersonation-failure":
              if (match$1.tl !== 0) {
                exit = 1;
              } else {
                tmp = JsxRuntime.jsx(AuthLoginPage.make, {
                  signInRequest: AuthLoginPage.signInRequest,
                  initialNotification: {
                    TAG: "Danger",
                    _0: I18n.t("Oops! It seems the impersonation has failed.")
                  },
                  recoveryRoute: AuthRoutes.recoveryRoute
                });
              }
              break;
            case "password-reset":
              if (match$1.tl !== 0) {
                exit = 1;
              } else {
                tmp = JsxRuntime.jsx(AuthLoginPage.make, {
                  signInRequest: AuthLoginPage.signInRequest,
                  initialNotification: {
                    TAG: "Success",
                    _0: I18n.t("Your password has been reset successfully. Please log in")
                  },
                  recoveryRoute: AuthRoutes.recoveryRoute
                });
              }
              break;
            case "recovery-email-sent":
              if (match$1.tl !== 0) {
                exit = 1;
              } else {
                tmp = JsxRuntime.jsx(AuthLoginPage.make, {
                  signInRequest: AuthLoginPage.signInRequest,
                  initialNotification: {
                    TAG: "Success",
                    _0: I18n.t("You should have received the recovery link by the next minutes.")
                  },
                  recoveryRoute: AuthRoutes.recoveryRoute
                });
              }
              break;
            case "session-expired":
              if (match$1.tl !== 0) {
                exit = 1;
              } else {
                tmp = JsxRuntime.jsx(AuthLoginPage.make, {
                  signInRequest: AuthLoginPage.signInRequest,
                  initialNotification: {
                    TAG: "Info",
                    _0: I18n.t("Oops! It seems your session has expired.")
                  },
                  recoveryRoute: AuthRoutes.recoveryRoute
                });
              }
              break;
            case "username-updated":
              let match$2 = match$1.tl;
              if (match$2 !== 0 && match$2.tl === 0) {
                tmp = JsxRuntime.jsx(AuthLoginPage.make, {
                  signInRequest: AuthLoginPage.signInRequest,
                  initialNotification: {
                    TAG: "Success",
                    _0: I18n.t("Your email update has been completed successfully.")
                  },
                  recoveryRoute: AuthRoutes.recoveryRoute,
                  initialUsername: match$2.hd
                });
              } else {
                exit = 1;
              }
              break;
            default:
              exit = 1;
          }
        } else {
          tmp = JsxRuntime.jsx(AuthLoginPage.make, {
            signInRequest: AuthLoginPage.signInRequest,
            recoveryRoute: AuthRoutes.recoveryRoute
          });
        }
        break;
      case "logout":
        let match$3 = subUrlPath.tl;
        if (match$3 !== 0) {
          let exit$1 = 0;
          switch (match$3.hd) {
            case "impersonation-failure":
            case "session-expired":
              exit$1 = 2;
              break;
            default:
              exit = 1;
          }
          if (exit$1 === 2) {
            if (match$3.tl !== 0) {
              exit = 1;
            } else {
              tmp = JsxRuntime.jsx(AuthLogoutPage.make, {});
            }
          }
        } else {
          tmp = JsxRuntime.jsx(AuthLogoutPage.make, {});
        }
        break;
      case "recovery":
        if (subUrlPath.tl !== 0) {
          exit = 1;
        } else {
          tmp = JsxRuntime.jsx(AuthLoginRecoveryPage.make, {
            loginRecoveryEmailSentRoute: AuthRoutes.loginRecoveryEmailSentRoute,
            passwordRecoveryRequest: AuthLoginRecoveryPage.passwordRecoveryRequest
          });
        }
        break;
      case "reset":
        let match$4 = subUrlPath.tl;
        if (match$4 !== 0) {
          let match$5 = match$4.tl;
          if (match$5 !== 0) {
            let match$6 = match$5.tl;
            if (match$6 !== 0 && match$6.tl === 0) {
              tmp = JsxRuntime.jsx(AuthLoginResetPage.make, {
                userId: match$4.hd,
                tokenId: match$5.hd,
                token: match$6.hd,
                successRoute: AuthRoutes.loginRecoverySuccessRoute,
                resetPasswordRequest: AuthLoginResetPage.resetPasswordRequest
              });
            } else {
              exit = 1;
            }
          } else {
            exit = 1;
          }
        } else {
          exit = 1;
        }
        break;
      case "signup":
        let match$7 = subUrlPath.tl;
        if (match$7 !== 0) {
          if (match$7.hd === "success" && match$7.tl === 0) {
            tmp = JsxRuntime.jsx(AuthSignupSuccessPage.make, {});
          } else {
            exit = 1;
          }
        } else {
          tmp = JsxRuntime.jsx(AuthSignupPage.make, {
            signupRequest: AuthSignupPage.signupRequest,
            ipAddressRequest: IpAddress.request
          });
        }
        break;
      case "update-username":
        let match$8 = subUrlPath.tl;
        if (match$8 !== 0) {
          let match$9 = match$8.tl;
          if (match$9 !== 0) {
            let match$10 = match$9.tl;
            if (match$10 !== 0) {
              let match$11 = match$10.tl;
              if (match$11 !== 0 && match$11.tl === 0) {
                tmp = JsxRuntime.jsx(AuthUsernameUpdatePage.make, {
                  userId: match$8.hd,
                  tokenId: match$9.hd,
                  token: match$10.hd,
                  username: match$11.hd,
                  usernameUpdateRequest: AuthUsernameUpdatePage.usernameUpdateRequest
                });
              } else {
                exit = 1;
              }
            } else {
              exit = 1;
            }
          } else {
            exit = 1;
          }
        } else {
          exit = 1;
        }
        break;
      default:
        exit = 1;
    }
  } else {
    exit = 1;
  }
  if (exit === 1) {
    tmp = JsxRuntime.jsx(Navigation.Redirect.make, {
      route: AuthRoutes.loginRoute
    });
  }
  newrecord.children = tmp;
  return JsxRuntime.jsx("div", newrecord);
}
let recoveryRoute = AuthRoutes.recoveryRoute;
let loginRecoveryEmailSentRoute = AuthRoutes.loginRecoveryEmailSentRoute;
let loginRecoverySuccessRoute = AuthRoutes.loginRecoverySuccessRoute;
let logoutImpersonationFailureRoute = AuthRoutes.logoutImpersonationFailureRoute;
let loginRoute = AuthRoutes.loginRoute;
let make = AuthRouter;
export { recoveryRoute, loginRecoveryEmailSentRoute, loginRecoverySuccessRoute, logoutImpersonationFailureRoute, loginRoute, styles, make };
/* styles Not a pure module */